<div class="page-header">
  <h1>{{ "reports" | i18n }}</h1>
</div>

<p>{{ "reportsDesc" | i18n }}</p>

<app-report-list [reports]="reports"></app-report-list>
